/**
 * `org-number` - organisation numbers in the OCR text, checksum-checked and
 * ranked by label and position (`findOrgNumbers`).
 *
 * Needs `text`. Provides `candidates:orgNumber`, each with a confidence. No
 * options.
 */

import { findOrgNumbers } from '../../orgnumber.js';
import type { Candidate, Step } from '../types.js';
import { summarize } from './support.js';

export const orgNumberStep: Step<Record<string, never>> = {
  name: 'org-number',
  needs: () => ['text'],
  provides: () => ['candidates:orgNumber'],
  async run(state, context) {
    const candidates: Candidate[] = findOrgNumbers(state.input.text ?? '').map((org) => ({
      value: org.formatted,
      source: context.id,
      confidence: org.confidence,
    }));
    return { candidates: { orgNumber: candidates }, added: summarize({ orgNumber: candidates }) };
  },
};
